export default __webpack_public_path__ + "static/media/vaccine-program-image.4ad036e6.png";